var paragraph_default = {
  "fontElementMap": "FlL9Y",
  "elementSpacing": "iJUzK",
  "text": "OsDxK iJUzK",
  "child": "JtXdA"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
